import React from 'react';
import { CalendarIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function BookingEmbed() {
  return <section className="py-16 bg-white" data-id="element-130">
      <div className="container mx-auto px-4 md:px-6" data-id="element-131">
        <div className="max-w-5xl mx-auto" data-id="element-132">
          <div className="text-center mb-10" data-id="element-133">
            <h2 className="text-3xl font-bold text-[#374047] mb-4" data-id="element-134">
              Book Your Complimentary Luxury Retreat
            </h2>
            <p className="text-lg text-[#374047]/80 max-w-3xl mx-auto" data-id="element-135">
              Select a convenient time for a 30-minute call with our team to
              discuss your eligibility for this exclusive paradise experience
            </p>
          </div>
          <div className="bg-[#F4E8D0]/30 rounded-xl p-6 md:p-8 shadow-sm" data-id="element-136">
            {/* Google Calendar Booking Embed */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-137">
              <iframe src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ08NlSHRfXX_3MWKJByit4Vxu0cJjhCI87yWfpsjxNgATwDMK-Q1WctMcKhg80WYbK6HzBkQMWo?gv=true" width="100%" height="600" frameBorder="0" className="w-full" title="Book Your Complimentary Luxury Retreat" style={{
              border: 0
            }} data-id="element-138"></iframe>
            </div>
            {/* Additional information */}
            <div className="mt-8 grid md:grid-cols-3 gap-6 text-center" data-id="element-139">
              <div className="bg-white p-5 rounded-lg shadow-sm" data-id="element-140">
                <CalendarIcon className="h-8 w-8 text-[#0099A1] mx-auto mb-3" data-id="element-141" />
                <h3 className="font-bold text-[#374047] mb-2" data-id="element-142">
                  30-Minute Consultation
                </h3>
                <p className="text-sm text-[#374047]/70" data-id="element-143">
                  Discuss your organization's retreat objectives and eligibility
                </p>
              </div>
              <div className="bg-white p-5 rounded-lg shadow-sm" data-id="element-144">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#0099A1] mx-auto mb-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-145">
                  <circle cx="12" cy="12" r="10" data-id="element-146"></circle>
                  <polyline points="12 6 12 12 16 14" data-id="element-147"></polyline>
                </svg>
                <h3 className="font-bold text-[#374047] mb-2" data-id="element-148">
                  Flexible Scheduling
                </h3>
                <p className="text-sm text-[#374047]/70" data-id="element-149">
                  Choose from available times that work best for you
                </p>
              </div>
              <div className="bg-white p-5 rounded-lg shadow-sm" data-id="element-150">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#0099A1] mx-auto mb-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-151">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" data-id="element-152"></path>
                  <polyline points="22 4 12 14.01 9 11.01" data-id="element-153"></polyline>
                </svg>
                <h3 className="font-bold text-[#374047] mb-2" data-id="element-154">No Obligation</h3>
                <p className="text-sm text-[#374047]/70" data-id="element-155">
                  Learn about the program with zero pressure or commitment
                </p>
              </div>
            </div>
          </div>
          <div className="text-center mt-8" data-id="element-156">
            <p className="text-sm text-[#374047]/70 mb-4" data-id="element-157">
              Can't find a suitable time? Contact us directly
            </p>
            <Button variant="outline" href="mailto:bookings@destameet.com" data-id="element-158">
              Email Our Team
            </Button>
          </div>
        </div>
      </div>
    </section>;
}